<div [formGroup]="form">
  <!-- Linha de campos (§8.10): centro de custo único + o toggle de rateio, na mesma fileira. -->
  <div class="row align-items-center">
    <div class="col-12 col-md-7">
      <app-select-pesquisavel
        [control]="idCentroCustoControl"
        [offlineList]="opcoesDeCentro"
        label="Centro de custo"
        idField="idCentroCusto"
        nameField="nome"
        [isOptional]="true"
        [disabled]="isRateioAtivo || isSomenteLeitura">
      </app-select-pesquisavel>
    </div>

    <div class="col-12 col-md-5 d-flex align-items-center vcc-toggle">
      <mat-slide-toggle color="primary" formControlName="isRateioCentroCusto">
        Rateio centro custo
      </mat-slide-toggle>
    </div>
  </div>

  <!-- Card de rateio: só existe com o toggle ligado. -->
  @if (isRateioAtivo) {
    <div class="vcc-card">
      <div class="vcc-card-titulo">
        <mat-icon class="material-symbols-outlined vcc-card-icone">pie_chart</mat-icon>
        <span>Rateio por centro de custo</span>
      </div>

      <div class="row align-items-center vcc-acoes">
        <div class="col-12 col-md-6">
          <button type="button" mat-stroked-button class="btn-secondary" [disabled]="isSomenteLeitura"
            (click)="selecionarConfiguracao()">
            <mat-icon class="material-symbols-outlined">percent</mat-icon> Selecionar configuração de rateio
          </button>
        </div>
        <div class="col-12 col-md-6 vcc-adicionar">
          <button type="button" mat-button class="btn-link" [disabled]="isSomenteLeitura" (click)="adicionarLinha()">
            <mat-icon class="material-symbols-outlined">add</mat-icon> Adicionar
          </button>
        </div>
      </div>

      <div formArrayName="rateioCentroCusto" (keydown.enter)="$event.preventDefault()">
        @for (linha of linhas; track linha; let i = $index) {
          <div class="vcc-linha" [formGroupName]="i">
            <div class="vcc-col-centro">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Centro de custo</mat-label>
                <mat-select formControlName="idCentroCusto">
                  <!-- Exclui os centros já escolhidos nas outras linhas (§8.10). -->
                  @for (c of opcoesPara(i); track c.idCentroCusto) {
                    <mat-option [value]="c.idCentroCusto">{{ c.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="vcc-col-valor">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor (R$)</mat-label>
                <input matInput formControlName="valor" [currencyMask]="mascaraDinheiro" class="vcc-num"
                  [readonly]="isSomenteLeitura" (blur)="aoSairDoValor(i)">
              </mat-form-field>
            </div>

            <div class="vcc-col-perc">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Percentual (%)</mat-label>
                <input matInput formControlName="percentual" [currencyMask]="mascaraPercentual" class="vcc-num"
                  [readonly]="isSomenteLeitura" (blur)="aoSairDoPercentual(i)">
              </mat-form-field>
            </div>

            <div class="vcc-col-acao">
              <button class="icon-mat-symbols-btn" type="button" mat-icon-button matTooltip="Remover linha" [disabled]="isSomenteLeitura"
                (click)="removerLinha(i)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
          </div>
        }

        @if (!linhas.length) {
          <p class="vcc-vazio">Nenhuma linha de rateio. Selecione uma configuração ou adicione linhas.</p>
        } @else {
          <!-- A barra e o "Total: x% (faltam y%)" são o componente da casa, o mesmo do Finanças. -->
          <app-percentual-progress-bar [somaPercentual]="somaPercentual"></app-percentual-progress-bar>
        }
      </div>
    </div>
  }
</div>
